import { gql } from "@apollo/client"
import { EledoPlan, KeyValuePair } from "./EledoPlanState"
import { EledoAddress } from "./EledoProfile"

export type EledoPlanChange = {
  step: number
	level: number
	levelRequest: number
	paymentRequest: string
	service: string
	subscriptionType: string
	subscriptionTypes: [KeyValuePair]
	paymentMethod: string
	paymentMethods: [KeyValuePair]
	planLimits: EledoPlan
	paymentPrice: number
	paymentDescription: string
	successUrl: string
	failureUrl: string
	inline: boolean
	billTo: EledoAddress
	settings: PlanChangeSettings
	success: boolean
	error: string
}

export type PlanChangeSettings = {
  type: string
	amount: string
	amountDecimal: number
	currencyCode: string
	description: string
	customId: string
	planId: string
	subscriptionId: string
	redirectUrl: string
	clientSecret: string
}

export type PlanChangeDataInput = {
	step: number
	levelRequest?: number
	paymentRequest?: string
	subscriptionType?: string
	paymentMethod?: string
	successUrl?: string
	failureUrl?: string
	inline?: boolean
	billTo?: EledoAddress
	responses?: PlanChangeResponsesInput
}

export type PlanChangeResponsesInput = {
	paypalSubscriptionId: string
	paypalOrderId: string
	stripeSessionId: string
	stripePaymentIntentId: string
	stripePaymentIntentClientSecret: string
	clientPortalUrl: string
}

export type EledoPlanChangeVars = {
  data: PlanChangeDataInput
}

export type EledoPlanChangeData = {
  planChange: EledoPlanChange
}

export const CHANGE_PRICING_PLAN = gql`
  mutation getPlanChange($data: PlanChangeDataInput) {
    planChange(data: $data) { step success error settings { redirectUrl } }
  }
`;


